import ServicePageTemplate from '../../components/sections/ServicePageTemplate';
import { SERVICE_PAGES } from '../../config/servicePagesData';

export default function IoTDevelopmentPage() {
  return <ServicePageTemplate service={SERVICE_PAGES.iotDevelopment} />;
}
